import { createSignal as createSolidSignal } from 'solid-js';
export function createSignal(value) {
    const [get, set] = createSolidSignal(value);
    return { get, set };
}
